import { render, staticRenderFns } from "./DateFormatter.vue?vue&type=template&id=4275674a&"
import script from "./DateFormatter.vue?vue&type=script&lang=js&"
export * from "./DateFormatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4275674a')) {
      api.createRecord('4275674a', component.options)
    } else {
      api.reload('4275674a', component.options)
    }
    module.hot.accept("./DateFormatter.vue?vue&type=template&id=4275674a&", function () {
      api.rerender('4275674a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-225bN8qqTdXRX/JS/DateFormatter.vue"
export default component.exports